import React, { useState } from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { Link } from 'react-router-dom';
import {
  ArrowRightOutlined,
  ClockCircleOutlined,
  ExclamationCircleFilled,
  KeyOutlined,
  MailOutlined,
  ProjectOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import './ContactsPage.css';

const CONTACT_EMAIL = 'Voronova.anastasiya99@yandex.ru';

const routes = [
  { icon: <ProjectOutlined />, title: 'Объект и расчёт', text: 'Вопросы по исходным данным, этапам оценки и готовому заключению', subject: 'Вопрос по объекту и расчёту' },
  { icon: <KeyOutlined />, title: 'Доступ к платформе', text: 'Вход, регистрация, восстановление доступа и работа личного кабинета', subject: 'Вопрос по доступу к платформе' },
  { icon: <TeamOutlined />, title: 'Партнёрство', text: 'Интеграции, корпоративные сценарии и совместные проекты', subject: 'Партнёрство с ЗЕМА' },
];

export default function ContactsPage() {
  const [form] = Form.useForm();
  const [activeRoute, setActiveRoute] = useState(0);
  const [formInvalid, setFormInvalid] = useState(false);

  const openMailApp = ({ name, email, phone, subject, message }) => {
    setFormInvalid(false);
    const body = `${message.trim()}\n\nИмя: ${name.trim()}\nEmail для ответа: ${email.trim()}${phone?.trim() ? `\nТелефон: ${phone.trim()}` : ''}`;
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject?.trim() || 'Обращение в ЗЕМА')}&body=${encodeURIComponent(body)}`;
  };

  const chooseRoute = (index) => {
    setActiveRoute(index);
    form.setFieldValue('subject', routes[index].subject);
    document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <main className="zema-public contacts-experience">
      <section className="contacts-hero">
        <img src="/images/contacts-consultation.png" alt="Консультация по коммерческому объекту в Санкт-Петербурге" width="1672" height="941" decoding="async" fetchpriority="high" />
        <div className="zema-wrap contacts-hero__inner">
          <div className="contacts-hero__card">
            <span className="contacts-kicker">Команда ЗЕМА</span>
            <h1>Разберём вопрос по существу</h1>
            <p>Объект, доступ к платформе или партнёрский сценарий — направим обращение сразу в нужный контекст.</p>
            <div className="contacts-hero__links"><a href={`mailto:${CONTACT_EMAIL}`}><MailOutlined /> {CONTACT_EMAIL}</a><a href="tel:+79319865716">+7 (931) 986-57-16</a></div>
          </div>
        </div>
      </section>

      <section className="contacts-routes zema-wrap" aria-labelledby="contacts-routes-title">
        <div className="contacts-section-head"><span className="contacts-kicker">Выберите тему</span><h2 id="contacts-routes-title">Так мы ответим быстрее</h2></div>
        <div className="contacts-routes__grid">
          {routes.map((route, index) => <button type="button" key={route.title} aria-pressed={activeRoute === index} onClick={() => chooseRoute(index)}><span className="contacts-route-number">0{index + 1}</span><i>{route.icon}</i><h3>{route.title}</h3><p>{route.text}</p><strong>{activeRoute === index ? 'Тема выбрана' : 'Подготовить обращение'} <ArrowRightOutlined /></strong></button>)}
        </div>
      </section>

      <section className="contacts-desk" id="contact-form">
        <div className="zema-wrap contacts-desk__inner">
          <div className="contacts-desk__meta">
            <span className="contacts-kicker">Рабочие контакты</span>
            <h2>Сообщение попадёт напрямую команде</h2>
            <p>Опишите адрес объекта и задачу. Если вопрос связан с расчётом, добавьте номер проекта — так мы быстрее восстановим контекст.</p>
            <dl>
              <div><dt>Почта</dt><dd><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></dd></div>
              <div><dt>Телефон</dt><dd><a href="tel:+79319865716">+7 (931) 986-57-16</a></dd></div>
              <div><dt>Время</dt><dd>Пн–Пт · 10:00–18:00 МСК</dd></div>
              <div><dt>Город</dt><dd>Санкт-Петербург</dd></div>
            </dl>
          </div>

          <div className="contacts-form-card">
            <div className="contacts-form-card__head"><div><span>Новое обращение</span><strong>{routes[activeRoute].title}</strong></div><ClockCircleOutlined /></div>
            <Form form={form} name="contact" layout="vertical" validateTrigger="onSubmit" onFinish={openMailApp} onFinishFailed={() => setFormInvalid(true)} onValuesChange={() => formInvalid && setFormInvalid(false)} requiredMark={false} className={`contacts-form${formInvalid ? ' contacts-form--invalid' : ''}`}>
              {formInvalid && <div className="contacts-form-alert" role="alert"><ExclamationCircleFilled /><span><strong>Проверьте выделенные поля</strong><small>Подсказки справа показывают, что нужно исправить.</small></span></div>}
              <div className="contacts-form-grid">
                <Form.Item label="Ваше имя" name="name" hasFeedback rules={[{ required: true, whitespace: true, message: 'Укажите ваше имя' }]}><Input size="large" autoComplete="name" maxLength={120} /></Form.Item>
                <Form.Item label="Email для ответа" name="email" hasFeedback rules={[{ required: true, message: 'Укажите email для ответа' }, { type: 'email', message: 'Введите корректный email' }]}><Input size="large" type="email" autoComplete="email" maxLength={254} /></Form.Item>
                <Form.Item label="Телефон" name="phone"><Input size="large" type="tel" autoComplete="tel" maxLength={40} /></Form.Item>
                <Form.Item label="Тема" name="subject"><Input size="large" maxLength={160} /></Form.Item>
              </div>
              <Form.Item label="Сообщение" name="message" hasFeedback rules={[{ required: true, whitespace: true, message: 'Опишите ваш вопрос' }]}><Input.TextArea rows={5} maxLength={1500} showCount /></Form.Item>
              <Form.Item name="agreement" valuePropName="checked" className="contacts-agreement" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('agreement')) }]}>
                <Checkbox>Я принимаю <Link to="/privacy" target="_blank" onClick={(event) => event.stopPropagation()}>политику конфиденциальности</Link> и даю <Link to="/consent" target="_blank" onClick={(event) => event.stopPropagation()}>согласие на обработку персональных данных</Link></Checkbox>
              </Form.Item>
              <Button type="primary" htmlType="submit" size="large">Открыть письмо <ArrowRightOutlined /></Button>
              <p className="contacts-form-note">Форма подготовит письмо в вашем почтовом приложении. Данные не отправляются через сайт без вашего действия.</p>
            </Form>
          </div>
        </div>
      </section>

      <section className="contacts-response zema-wrap">
        <div><ClockCircleOutlined /><span>Обычный вопрос</span><strong>в течение рабочего дня</strong></div>
        <div><ProjectOutlined /><span>Вопрос по проекту</span><strong>сначала проверим контекст расчёта</strong></div>
        <div><TeamOutlined /><span>Партнёрство</span><strong>согласуем короткий созвон</strong></div>
      </section>
    </main>
  );
}
